module.exports = __webpack_public_path__ + "static/media/hlaup_hjol.55b90fcf.png";